@if (accessLimit.limited()) {
  <div
    class="flex flex-wrap items-center justify-center gap-6 border border-[#FA933D] bg-[#FFF7ED] px-8 py-4 text-center font-[Inter] text-sm text-[#3E4F6C]"
    role="status"
    data-testid="access-limit-banner"
  >
    <app-icon class="shrink-0 text-[#F57700]" size="m" name="alert-warning" />
    <span>{{ message() }}</span>
    @if (!accessLimit.inherited()) {
      <!-- Passthrough: the settings window's veil covers this bar, and a click on it must not just close the window. -->
      <app-button2 class="shrink-0" appearance="primary" size="s" data-settings-window-passthrough (click)="act()">
        {{ actionLabel() }}
      </app-button2>
    }
  </div>
}
